import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ScreenService } from '../../shared/services/screen/screen.service';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe
  ],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
})
export class AboutComponent implements OnInit {
  isMobile = false;
  services: any[] = [];
  private destroyRef = inject(DestroyRef);

  constructor(
    private screenService: ScreenService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.loadServices();

    this.screenService.isMobile$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isMobile) => {
        this.isMobile = isMobile;
      });

    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadServices();
      });
  }

  private loadServices(): void {
    this.translate.get('about.services.items').subscribe((data) => {
      if (Array.isArray(data)) {
        this.services = data;
      }
    });
  }
}

